import { HolidayCareGroup, School } from '@awo-care/shared-core';

export function validateHolidayCareGroup(
  group: Pick<HolidayCareGroup, 'name' | 'kreis' | 'schoolIds'>,
  allSchools: School[],
  selfGroupId: string | undefined,
): { valid: true } | { valid: false; reason: string } {
  if (!group.name?.trim()) return { valid: false, reason: 'Name darf nicht leer sein' };
  if (!group.kreis) return { valid: false, reason: 'Kreis muss gewählt sein' };
  if (!group.schoolIds?.length) return { valid: false, reason: 'Mindestens eine Schule auswählen' };

  const members = allSchools.filter((s) => s.id && group.schoolIds.includes(s.id));
  const hosts = members.filter((s) => s.holidayCare === true);
  if (hosts.length > 1) {
    return {
      valid: false,
      reason: `Ein Verbund darf nur eine Schule mit Ferienbetreuung enthalten. Aktuell: ${hosts.map((s) => s.schoolName).join(', ')}`,
    };
  }
  const conflict = members.find((s) => s.holidayCareGroupId && s.holidayCareGroupId !== selfGroupId);
  if (conflict) return { valid: false, reason: `Schule "${conflict.schoolName}" ist bereits in einem anderen Verbund` };
  return { valid: true };
}
